import axios from '../../../axios';
import IJobBoard from '../types/IJobBoard';
import IJobBoardSaveDTO from '../types/IJobBoardSaveDTO';
const url = '/jobsearch/api/job-board';
const urlJobs = '/jobsearch/api/jobs/';

export const saveJobBoard = (jobBoardData: IJobBoardSaveDTO) => axios.post(`${url}`, jobBoardData);

export const getInventory = (id: string) => axios.get(`${url}/get-inventory/${id}`);

export const getJobBoardsByName = (jobBoardName: string) =>
  axios.get(`${url}/getByRecruiterId/${jobBoardName}`);

export const canShareJobToJobBoard = (jobBoardName: string) =>
  axios.get(`${url}/canShareJobBoard/${jobBoardName}`);

export const deleteJobBoardAccount = (id: string) => axios.delete(`${url}/delete/${id}`);

export const postToMultipleJobBoards = (
  jobBoards: string[],
  jobIds: string,
  jobBoardAccountEmail: string
) =>
  axios.get(`${urlJobs}post-to-multiple-jobboards/${jobBoards}/${jobIds}/${jobBoardAccountEmail}`);

export const unPublishJobFromJobBoard = (jobId: string, jobBoard: string) =>
  axios.get(`${urlJobs}unpublish-job-from-job-board/${jobId}/${jobBoard}`);

export const deleteJobFromJobBoard = (jobBoard: string, jobId: string) =>
  axios.delete(`${urlJobs}${jobBoard}/${jobId}`);

export const getJobStatsPostedOnJobBoards = () => axios.get(`${urlJobs}get-counts-paid-job-boards`);

export const saveFreeJobBoardSettings = (jobBoardData: IJobBoard) =>
  axios.post('/jobsearch/api/free-job-board-settings', jobBoardData);

export const getFreeJobBoardSettings = (workspaceId: string) =>
  axios.get(`/jobsearch/api/get-free-job-board-settings/${workspaceId}`);
